import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';
import { DayPickerRangeController } from 'react-dates';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import moment from 'moment';
import { Loader } from 'kangarootime-ui';

const CopySchedulesDialog = ({ isOpen, onClose, copySchedules, performingAction }) => {
  // initial start / end date are the following monday and friday
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [focusedDate, setFocusedDate] = useState(startDate);
  const TODAY = moment();
  const DATES_SELECTED = Boolean(startDate) && Boolean(endDate);

  const handleDateChange = ({ startDate, endDate }) => {
    setStartDate(startDate);
    setEndDate(endDate);
  };

  const handleFocusChange = date => {
    const newFocused = !focusedDate ? startDate : date;
    setFocusedDate(newFocused);
  };

  const closeDialog = () => {
    // reset state before closing
    setStartDate(null);
    setEndDate(null);
    setFocusedDate(null);

    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={closeDialog}>
      <DialogTitle>Copy this schedule to...</DialogTitle>
      <DialogContent>
        { DATES_SELECTED
          ? <DialogContentText>
            The week of {moment(startDate).format('MMMM DD')}
          </DialogContentText>
          : null
        }
        <DayPickerRangeController
          hideKeyboardShortcutsPanel
          numberOfMonths={1}
          startDate={startDate}
          endDate={endDate}
          startDateOffset={day => moment(day).startOf('week')}
          endDateOffset={day => moment(day).endOf('week')}
          onDatesChange={handleDateChange}
          onFocusChange={handleFocusChange}
          isOutsideRange={date => date < TODAY.endOf('week').toDate()}
        />
        <Loader loading={performingAction}>
          <DialogActions>
            <Button onClick={closeDialog}>
              Cancel
            </Button>
            { DATES_SELECTED
              ? <Button onClick={() => copySchedules(startDate, endDate)}>
                Copy
              </Button>
              : null
            }
          </DialogActions>
        </Loader>
      </DialogContent>
    </Dialog>
  );
};

CopySchedulesDialog.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  copySchedules: PropTypes.func,
  performingAction: PropTypes.bool
};

export default CopySchedulesDialog;
